import { api } from '~/redux/api/createApi';
import { useClientSlug } from '~/routing/clientSlug';

type Options = {
  skip?: boolean;
};

/**
 * Subscribes to the app's single permission request.
 *
 * Every permission read goes through here, so RTK Query collapses concurrent
 * consumers onto one in-flight promise and one cache entry: a component
 * mounting while the request is still open waits on it instead of issuing its
 * own. Holding a real subscription (rather than seeding the cache imperatively)
 * is also what keeps the entry from being garbage-collected out from under
 * later readers.
 */
export function useAllPermissionsQuery({ skip }: Options = {}) {
  // Keyed by tenant: `enterClientSlug` crosses clients in place without a page
  // load, so a changed slug is what makes the next tenant refetch rather than
  // read the previous one's answers.
  const clientSlug = useClientSlug();

  return api.endpoints.checkAllPermissions.useQuery(clientSlug, { skip });
}
